export const STATUS_TYPE: { [key: string]: string } = {
  ACCEPTED: "Zaakceptowana",
  REPORTED: "Zgłoszona",
  STARTED: "Rozpoczęta",
  FINISHED: "Zakończona",
  OFFERED: "Do oddania",
};
